module.exports = __webpack_public_path__ + "static/img/CH.783784a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/countryFlag/CH.svg
// module id = zkZ7
// module chunks = 66